import Vue from "vue/dist/vue.js";
import mapFunctions from "./map";

Vue.component("big-map", {
    delimiters: ["[[", "]]"],
    template: "#big-map",
    props: ["actions", "activeMarker", "fullScreen", "searchOnMove"],
    data: function() {
        return {
            m: null,
            markerLayer: null,
            loading: false,
            redraw: true,
            markers: {},
            points: []
        };
    },
    watch: {
        actions: function(val) {
            this.loading = true;
            this.markers = {};
            if (val != null) {
                if (this.m == null) {
                    this.drawMap();
                }

                this.actions = val;
                this.addActionsToMap(this.actions);
            }
        },
        fullScreen: function(val) {
            this.redrawMap();
        }
    },
    created: function() {
        this.setZoomAndCenter = mapFunctions.setZoomAndCenter;
        this.addGeometryToMap = mapFunctions.addGeometryToMap;
        this.mapConfig = mapFunctions.mapConfig;
        this.getIcon = mapFunctions.getIcon;
    },
    methods: {
        drawMap: function() {
            var center = SMap.Coords.fromWGS84(
                14.438710255616163,
                50.074427024615723
            );
            this.m = new SMap(JAK.gel("big_map_holder"), center, 11);

            this.m.addDefaultLayer(SMap.DEF_SMART_BASE).enable();

            var sync = new SMap.Control.Sync();
            this.m.addControl(sync);

            this.m.addDefaultControls();

            const vm = this;
            var listener = function(e) {
                if (!vm.loading) {
                    if (
                        e.type == "control-mouse-move" ||
                        e.type == "zoom-stop"
                    ) {
                        var coords = vm.getMapBorder();
                        if (vm.searchOnMove) {
                            vm.redraw = false;
                        }

                        vm.$emit("mappositionupdated", coords);
                    }
                }
            };

            var signals = this.m.getSignals();
            signals.addListener(window, "*", listener);
        },
        addActionsToMap: function() {
            this.loading = true;
            if (this.markerLayer == null) {
                this.markerLayer = new SMap.Layer.Marker();
                //var clusterer = new SMap.Marker.Clusterer(this.m);
                //this.markerLayer.setClusterer(clusterer);
                this.m.addLayer(this.markerLayer);
                this.markerLayer.enable();
            } else {
                this.markerLayer.removeAll();
            }

            this.points = [];
            for (var action of this.actions) {
                var icon = this.getIcon(action, false);

                var options = {};
                var center = SMap.Coords.fromWGS84(action.lon, action.lat);
                var marker = new SMap.Marker(center, action.id, { url: icon });
                this.markers[action.id] = {
                    marker: marker,
                    action: action
                };

                var card = new SMap.Card();
                var html = `
                    <div class="card_body_inner card_body_inner_%severity">
                    <h3>
                        Praha %city_part
                    </h3>
                    <h2>%name</h2>
                    <p class="detail_link">
                        <a href="/action/%id" target="_blank">detail</a>
                    </p>
                    <img class="severity_icon" src="/static/v1/img/icon_cover.png" />
                    </div>
                `
                    .replace("%id", action.id)
                    .replace("%city_part", action.city_part.join(", "))
                    .replace("%severity", action.severity)
                    .replace("%name", action.name);
                card.getBody().innerHTML = html;
                marker.decorate(SMap.Marker.Feature.Card, card);

                this.points.push(center);
                this.markerLayer.addMarker(marker);
            }

            this.markerLayer.enable();
            if (this.redraw) {
                this.redrawMap();
            }

            this.loading = false;
            this.redraw = true;
        },
        getMapBorder: function getMapBorder() {
            var size = this.m.getSize();
            var w = Math.round(size.x / 2);
            var h = Math.round(size.y / 2);
            var leftTop = new SMap.Pixel(-w, -h);
            var leftTopCoords = leftTop.toCoords(this.m);
            var leftTopWGS = leftTopCoords.toWGS84();
            var botRight = new SMap.Pixel(w, h);
            var botRightCoords = botRight.toCoords(this.m);
            var botRightWGS = botRightCoords.toWGS84();
            return [leftTopCoords, botRightCoords];
        },
        highlightMarker: function(val) {
            if (val != null) {
                var marker = this.markers[val].marker;
                //this.markerLayer.removeMarker(marker);

                var icon = this.getIcon(this.markers[val].action, true);

                //var marker = new SMap.Marker(marker.getCoords(), val, {
                //    url: icon
                //});
                //this.markerLayer.addMarker(marker);
                marker.setURL(icon);
                this.markerLayer.redraw();
            }
        },
        normaliseMarker: function(val) {
            if (val != null) {
                var marker = this.markers[val].marker;
                //this.markerLayer.removeMarker(marker);

                var icon = this.getIcon(this.markers[val].action, false);

                //var marker = new SMap.Marker(marker.getCoords(), val, {
                //    url: icon
                //});
                //this.markerLayer.addMarker(marker);

                marker.setURL(icon);
                this.markerLayer.redraw();
            }
        },
        redrawMap: function(val) {
            if (this.points.length > 0) {
                var center_zoom = this.m.computeCenterZoom(this.points);
                this.m.setCenterZoom(center_zoom[0], center_zoom[1]);
            } else {
                var center = SMap.Coords.fromWGS84(
                    14.438710255616163,
                    50.074427024615723
                );
                this.m.setCenterZoom(center, 11);
            }
        }
    }
});
